// extracted by mini-css-extract-plugin
export default {"input-group":"SelectGroup_input-group__i3CSt","label":"SelectGroup_label__dx+7+","input-group-text":"SelectGroup_input-group-text__Jpigh"};